import img1 from './Diagnostico/img1.jpg'
import img2 from './Diagnostico/img2.jpg'
import img3 from './Diagnostico/img3.jpg'
import img4 from './Diagnostico/img4.jpg'
import img5 from './Diagnostico/img5.jpg'
import img6 from './Diagnostico/img6.jpg'
import img7 from './Diagnostico/img7.jpg'
import img19 from './Diagnostico/img19.jpg'
import img20 from './Diagnostico/img20.jpg'
import img21 from './Diagnostico/img21.jpg'
import img22 from './Diagnostico/img22.jpg'
import img23 from './Diagnostico/img23.jpg'
import img25 from './Diagnostico/img25.jpg'
import React, { Component } from 'react'
import { Card, Pagination, Row, Col, Container } from 'react-bootstrap'
import { Footer } from './Footer'
import { Navigation } from './Navigation'

export class Diagnostico2 extends Component {
    render() {
        // Estructura de datos para mapear las cards fácilmente
        const productos = [
            { img: img1, title: "Esfigmomanómetro digital" },
            { img: img4, title: "Esfigmomanómetro digital y libre de mercurio" },
            { img: img7, title: "Esfigmomanómetros" },
            { img: img22, title: "Estetoscopio de acero inoxidable doble campana" },
            { img: img2, title: "Esfigmomanómetro digital" },
            { img: img5, title: "Esfigmomanómetro libre de mercurio" },
            { img: img21, title: "Estetoscopio" },
            { img: img23, title: "Estetoscopio lux" },
            { img: img3, title: "Esfigmomanómetro digital" },
            { img: img6, title: "Esfigmomanómetro libre de mercurio y esfigmomanómetro de mesa" },
            { img: img19, title: "Estetoscopio de 1 y doble campana" },
            { img: img20, title: "Estetoscopios Rappaport" },
            { img: img25, title: "Varios" }
        ];

        return (
            <div>
                <Navigation />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>Diagnóstico - Página 2</h1>
                        </Col>
                    </Row>
                    <br />

                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/diagnostico">{1}</Pagination.Item>
                        <Pagination.Item active>{2}</Pagination.Item>
                    </Pagination>
                    <br />

                    {/* Rejilla optimizada: 1 columna en móvil, 2 en tablet, 3 en desktop */}
                    <Row xs={1} md={2} lg={3} className="g-5 text-center">
                        {productos.map((item, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow-sm border-0">
                                    <Card.Img 
                                        variant="top" 
                                        src={item.img} 
                                        style={{ height: '300px', objectFit: 'contain', padding: '15px' }} 
                                    />
                                    <Card.Body className="d-flex align-items-center justify-content-center">
                                        <Card.Title style={{ fontSize: '1.3rem' }}>{item.title}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    <br />
                    <Pagination className="justify-content-center mt-4" size="lg">
                        <Pagination.Item href="/diagnostico">{1}</Pagination.Item>
                        <Pagination.Item active>{2}</Pagination.Item>
                    </Pagination>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}